import advancedFormat from 'dayjs/plugin/advancedFormat';
import isToday from 'dayjs/plugin/isToday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { dayjs } from 'src/utils/dayjs-config.utils';

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(isToday);
dayjs.extend(utc);
dayjs.extend(timezone);

type DatePropertyType = Date | string | number | null;

export const getDateObject = (date?: DatePropertyType) =>
  new Date(date ?? Date.now());

export const getValueOf = (date?: DatePropertyType) =>
  getDateObject(date).valueOf();

export const getDayJSObject = (date?: DatePropertyType) =>
  date ? dayjs(date) : dayjs();

export const getPrevMonthDateObject = (date?: DatePropertyType) =>
  getDayJSObject(date).subtract(1, 'month').toDate();

// https://day.js.org/docs/en/display/format
export const getToday = () => `${dayjs().format('ddd, MMM Do')}`; // Today is Mon, May 23rd

export const endOfDay = (date: Date | string | number): number =>
  dayjs(date).endOf('day').valueOf();

export const utcToDate = (date: Date | string | number): Date =>
  dayjs(date).utc().toDate();
